import { useAuth } from "@/contexts";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import Login from "@/pages/login";
import { Box, Center, Spinner } from "@chakra-ui/react";
import { ReactNode, useState } from "react";

function AuthGuard({ children, unauth }: { children: ReactNode; unauth?: boolean }) {
  const [IsLoading, setIsLoading] = useState(true);

  const { isAuthenticated } = useAuth();
  useIsomorphicLayoutEffect(() => {
    if (!isAuthenticated) {
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  if (IsLoading) {
    return (
      <Box>
        <Center gap={"1rem"}>
          <Spinner size={"xl"} color={"#1e1e1e"} />
        </Center>
      </Box>
    );
  }

  if (!IsLoading && !isAuthenticated) {
    return <Login />;
  } else {
    return <>{children}</>;
  }
}

export { AuthGuard };
